import {createBrowserHistory} from "history";

// Initialize the browser history
const history = createBrowserHistory();

export default history;